var map = {
	"./amenidades/amenidades.module": [
		"./src/app/pages/home-page/amenidades/amenidades.module.ts",
		"common",
		"amenidades-amenidades-module"
	],
	"./anuncios/anuncios.module": [
		"./src/app/pages/home-page/anuncios/anuncios.module.ts",
		"anuncios-anuncios-module"
	],
	"./contabilidad/contabilidad.module": [
		"./src/app/pages/home-page/contabilidad/contabilidad.module.ts",
		"contabilidad-contabilidad-module"
	],
	"./empresa/empresa.module": [
		"./src/app/pages/home-page/empresa/empresa.module.ts",
		"common",
		"empresa-empresa-module"
	],
	"./pages/catalogo/catalogo.module": [
		"./src/app/pages/catalogo/catalogo.module.ts",
		"common",
		"pages-catalogo-catalogo-module"
	],
	"./pages/home-page/homePage.module": [
		"./src/app/pages/home-page/homePage.module.ts",
		"common",
		"pages-home-page-homePage-module"
	],
	"./punto-acceso/punto-acceso.module": [
		"./src/app/pages/home-page/punto-acceso/punto-acceso.module.ts",
		"punto-acceso-punto-acceso-module"
	],
	"./support-ticket-list/support-ticket-list.module": [
		"./src/app/pages/home-page/support-ticket-list/support-ticket-list.module.ts",
		"support-ticket-list-support-ticket-list-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;